function clamp( value: number, min?: number, max?: number) : number
{
	if ( max !== undefined && min !== undefined )
	{
		return value > min ? ( value < max ? value : max ) : min;
	}

	if ( max !== undefined )
	{
		return value <= max ? value : max;
	}

	if ( min !== undefined )
	{
		return value >= min ? value : min;
	}

	return value;
}
